import axios from 'axios';
import { MAP_API_KEY } from '../react-pages/ContactUs/Map/MapWrapper';
import { setSelectedCurrencyAction } from '../store/SelectedCurrency/action';

export const defineCurrency = (selectedCurrency: string, store: any) => {
  window.navigator.geolocation.getCurrentPosition(
    async (e) => {
      const lat = e?.coords?.latitude;
      const lng = e?.coords?.longitude;
      const res: any = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${MAP_API_KEY}`
      );
      const resultIdx = res?.data?.results?.findIndex((item: any) => item?.types?.includes('country')) || 0;
      let addresses = res?.data?.results?.[resultIdx]?.address_components || [];
      let obj = addresses.find((item: any) => item?.types?.includes('country'));
      if (!selectedCurrency) {
        const isUsa = ['US', 'USA'].includes(obj?.short_name?.toUpperCase());
        store.dispatch(setSelectedCurrencyAction(isUsa ? 'USD' : 'EUR'));
      }
      console.log('country', obj?.short_name);
    },
    (e) => {
      console.log('error', e);
      if (!selectedCurrency) {
        store.dispatch(setSelectedCurrencyAction('EUR'));
      }
    }
  );
};
